<template>
    <div>
        <div v-if="false">This page has been removed. We apologize for any inconvenience. Please visit <a href="https://www.studiesweekly.com/get-a-quote/">this page</a> to receive a quote.</div>
        <div v-else class="home container my-5 pb-5">
            <!-- PDF Version -->
    <!--        <div v-show="!printing" style="position: absolute;top:15px;left:15px;">-->
    <!--            <b-button variant="link" :href="'https://cdn.studiesweekly.com/PDFOrderForms/' + '21+' + selectedState.fullState + '.pdf'" target="_blank">-->
    <!--                PDF Version-->
    <!--            </b-button>-->
    <!--        </div>-->

            <!-- Header -->
            <div class="text-center my-3 mb-2" v-click-outside="handleClickOutside">
                <span v-show="editingState || !selectedState">
                    <select class="form-control text-capitalize w-25 d-inline"
                            ref="stateSelect"
                            v-if="states"
                            v-model="selectedState"
                            @change="setSelectedState"
                    >
                        <option selected disabled :value="null">Select A State</option>
                        <option v-for="state in states"
                                :key="state.state"
                                :value="state"
                        >
                            {{state.fullState}}
                        </option>
                    </select>
                </span>
                <span v-show="!editingState" v-if="states && selectedState">
                    <h2 class="state-header d-inline" @click="editState"><strong>{{selectedState.fullState}}</strong></h2>
                </span>
                <h2 class="d-inline"> Order Form <span class="dot">&#9679;</span> {{yearRange}} School Year</h2>

                <div v-show="printing">{{guid}}</div>
            </div>

            <!-- Form Inputs -->

            <b-form ref="form" @submit.stop.prevent="onSubmit" class="pb-2">
                <b-form-row>
                    <b-form-group label="Ship to Name">
                        <b-form-input type="text" name="name" v-model="form.name" required></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <template v-slot:label>Bill to Name<span class="d-none d-sm-inline"> (if different)</span></template>
                        <b-form-input type="text" name="name" v-model="form.billingName"></b-form-input>
                    </b-form-group>
                </b-form-row>

                <b-form-row>
                    <b-form-group label="Email Address">
                        <b-form-input type="email" name="email" v-model="form.email" required></b-form-input>
                    </b-form-group>

                    <b-form-group>
                        <template v-slot:label>Bill to Email<span class="d-none d-sm-inline"> (if different)</span></template>
                        <b-form-input type="email" name="email" v-model="form.billingEmail"></b-form-input>
                    </b-form-group>
                </b-form-row>

                <b-form-row>
                    <b-form-group label="School Name">
                        <b-form-input type="text" v-model="form.school" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="School Start Date">
                        <v-date-picker v-model="form.start" required>
                            <template v-slot="{ inputValue, inputEvents }">
                                <b-input
                                    :value="inputValue"
                                    v-on="inputEvents"
                                />
                            </template>
                        </v-date-picker>
                    </b-form-group>
                </b-form-row>

                <b-form-row>
                    <b-form-group label="Address">
                        <b-form-input type="text" name="street" v-model="form.address" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Unable to Receive Window">
                        <v-date-picker v-model="form.blackoutWindows[0]"
                                       mode="range"
                                       :min-date="new Date()"
                                       :disabled-dates="form.blackoutWindows[1]"
                                       :columns="$screens({ default: 1, lg: 2 })"
                                       :rows="$screens({ default: 2, lg: 1 })"
                        >
                            <template v-slot="{ inputValue, inputEvents }">
                                <b-form-input
                                    class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                    v-model="inputValue"
                                />
                            </template>
                        </v-date-picker>
                    </b-form-group>
                </b-form-row>

                <b-form-row>
                    <b-form-group label="City">
                        <b-form-input type="text" name="city" v-model="form.city" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Unable to Receive Window 2">
                        <v-date-picker v-model="form.blackoutWindows[1]"
                                       mode="range"
                                       :min-date="new Date()"
                                       :disabled-dates="form.blackoutWindows[0]"
                                       :columns="$screens({ default: 1, lg: 2 })"
                                       :rows="$screens({ default: 2, lg: 1 })"
                        >
                            <template v-slot="{ inputValue, inputEvents }">
                                <b-form-input
                                    class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                    v-model="inputValue"
                                />
                            </template>
                        </v-date-picker>
                    </b-form-group>
                </b-form-row>

                <b-form-row>
                    <b-form-group label="State">
                        <b-form-input type="text" name="state" v-model="form.state" required></b-form-input>
                    </b-form-group>

                    <b-form-group label="Purchase Order">
                        <b-form-input type="text" v-model="form.purchaseOrder"></b-form-input>
                    </b-form-group>

                </b-form-row>

                <b-form-row>
                    <b-form-group label="Zip code">
                        <b-form-input type="text" name="postal" v-model="form.zip" required></b-form-input>
                    </b-form-group>
                    <b-form-group label="Phone Number">
                        <b-form-input type="tel" name="phone" v-model="form.phone" required :formatter="phoneFormatter"></b-form-input>
                    </b-form-group>
                </b-form-row>
                <b-form-row>
                    <b-form-group>
                        <template>
                            <b-form-checkbox v-model="form.canShipPartial" plain>Ship All Materials Together</b-form-checkbox>
                            <b-form-checkbox v-model="form.cantShipPartial" plain>Ship Each Product When Available</b-form-checkbox>
                        </template>
                        <template #label>
                            <label class="mr-2">Shipping</label>
                            <font-awesome-icon id="ship_partial" :icon="['fas', 'info-circle']" ></font-awesome-icon>
                            <b-popover target="ship_partial" triggers="hover">
                                <p>Please select your preferred shipping option, but note that our ability to fulfill your request may change based on the season and volume of orders.</p>
    <!--                            <p><strong>Ship all materials together: </strong>If you want all your products to arrive together, please be aware this may cause your shipments to be delayed until all materials are in stock and ready to ship.</p>-->
    <!--                            <p><strong>Ship each product when in stock: </strong>Shipments of social studies, science, or well-being products may ship at different times depending on when the print product is in stock and ready to ship.</p>-->
                            </b-popover>
                        </template>
                    </b-form-group>
                </b-form-row>


                <p><strong>Avoid delays to your order!</strong> All information must be complete. Enter N/A if not applicable. Customer responsible for any duplicate orders.</p>


                <div class="pagebreak"></div>
                <div v-show="printing">{{guid}}</div>

            <!-- Product Table -->
                <b-overlay :show="fetchingStateData">
                    <b-table-simple bordered striped>
                        <b-thead>
                            <b-tr><b-th colspan="12" variant="secondary" class="font-weight-normal">Bundle pricing: Order multiple subjects, for the same grade and quantity, to receive discounted pricing.</b-th></b-tr>
                            <b-tr><b-th colspan="12" class="font-weight-normal">Pricing is per student for orders 10+.  Sales tax will be added to order.</b-th></b-tr>
                            <b-tr variant="secondary" class="text-center">
                                <b-th>Grade</b-th>
                                <b-th>Item</b-th>
                                <b-th>Title</b-th>
                                <b-th>Format</b-th>
                                <b-th>Classes</b-th>
                                <b-th>Student Qty</b-th>
                                <b-th>Price</b-th>
                                <b-th>Subtotal</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-if="statePublications">
                            <template v-for="(items, i) in statePublications">
                                <b-tr v-for="(product, j) in items" :key="`pub-${i}-${j}`" class="align-middle">
                                    <!-- Grade -->
                                    <b-td v-if="j === 0"
                                          class="text-center align-middle"
                                          :rowspan="items.length"
                                    >
                                        {{items[0].grade}}
                                    </b-td>
                                    <!-- Sku -->
                                    <b-td class="text-center align-middle">{{product.physicalSku}}</b-td>
                                    <!-- Title -->
                                    <b-td class="px-1 align-middle">{{product.title}}</b-td>
                                    <!-- Format -->
                                    <b-td class="align-middle">
                                        <div v-show="printing">{{getFormatText(orders[product.sku].format)}}</div>
                                        <b-select class="h-100" v-show="!printing"  v-model="orders[product.sku].format" @change="handleTableChange()">
                                            <b-select-option v-for="({value, label}, i) in productFormatsAdjusted[product.availability]"
                                                             :value="value"
                                                             :key="`productFormat[${i}]`"
                                            >
                                                {{label}}
                                            </b-select-option>
                                        </b-select>
                                    </b-td>
                                    <!-- Classes-->
                                    <b-td class="align-middle">
                                        <b-input v-show="!printing" type="number" min="0" placeholder="__" v-model="orders[product.sku].numClasses"></b-input>
                                        <div v-show="printing">{{orders[product.sku].numClasses}}</div>
                                    </b-td>
                                    <!-- Num Students -->
                                    <b-td class="align-middle">
                                        <b-input v-show="!printing" type="number" min="0" step="1" placeholder="__" v-model="orders[product.sku].quantity" @input="handleTableChange()"></b-input>
                                        <div v-show="printing">{{orders[product.sku].quantity}}</div>
                                    </b-td>
                                    <!-- Price -->
                                    <b-td class="align-middle">
                                        <div>{{ orders[product.sku].unit_price}}</div>
                                    </b-td>
                                    <!-- Subtotal -->
                                    <b-td class="align-middle">
                                        <div v-if="orders[product.sku].unit_price">
                                            {{ (orders[product.sku].unit_price * orders[product.sku].quantity).toFixed(2)}}
                                        </div>
                                    </b-td>
                                </b-tr>
                            </template>
                            <b-tr class="text-center align-middle">
                                <b-td colspan="6" class="px-3 py-2"></b-td>
                                <b-td class="py-2 font-weight-bold">Shipping:</b-td>
                                <b-td class="py-2">{{shippingPrice}}</b-td>
                            </b-tr>
                            <b-tr class="text-center align-middle">
                                <b-td colspan="6" class="text-left font-weight-bold px-3 py-2">For multi-year discounts, please call (866) 311-8734</b-td>
                                <b-td class="py-2 font-weight-bold">Total:</b-td>
                                <b-td class="py-2">{{cartTotal}}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </b-overlay>
                <!-- Buttons -->
                <div class="float-right" v-show="!printing">
                    <b-button type="submit" class="mx-2" variant="success" @click="printForm">Print Form</b-button>
        <!--            <b-button type="submit" class="mx-2" variant="primary" @click="onSubmit">Submit OrderDetails</b-button>-->
                </div>
            </b-form>

            <!-- Footer -->
            <div class="w-75 footer">
                <div class="d-inline-block w-25 footer-img">
                    <img src="https://cdn.studiesweekly.com/logo/Black+Stacked-01.png">
                </div>
                <div class="d-inline-block w-75">
                    <div><strong>Phone</strong>: 866-311-8734 • <strong>Fax</strong>: 866-531-5589</div>
                    <div><strong>Orders</strong>: orders@studiesweekly.com • <strong>Questions</strong>: service@studiesweekly.com</div>
                    <div><strong>Web</strong>: www.studiesweekly.com • <strong>Support</strong>: support.studiesweekly.com</div>
                    <div><strong>Remit Payment</strong>: Studies Weekly, Inc, 1140 N 1430 W, Orem, UT 84057</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import states from '@/common/states'
import {
    displaySkuWithTopic,
    printOnlineMinimumQuantity,
    productPricesOfFormat,
    guidGenerator,
} from "@/common/utils";
import product_formats from "@/common/product_formats";
import product_prices from "@/common/product_prices";
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name: "OrderForm",
    components: {DatePicker},
    computed: {
        ...mapState({
            stateData: state => state.stateData.stateData,
            publicationResources: state => state.stateData.stateData.publicationResources,
            products: state => _.orderBy(state.cart.products, 'grade'),
            publications: state => state.stateData.stateData.publications,
            physicalProducts: state => state.stateData.physicalProducts,

        }),
        yearRange() {
            let date = new Date();
            if (date.getMonth() >= 2)
                return `${date.getFullYear()}-${date.getFullYear()+1}`;
            return `${date.getFullYear()-1}-${date.getFullYear()}`;
        },
        legacyIdSkus() {
            let skus = {};
            for (let i = 0; i < this.physicalProducts.length; ++i) {
                skus[this.physicalProducts[i].ID] = this.physicalProducts[i].sku;
            }
            return skus;
        },
        statePublications() {
            if (!this.selectedState || !this.publications)
                return null;

            // Get pubs by state
            let pubs = this.publications.filter((pub) => {
                return (pub.state === this.selectedState.state &&
                    pub.retired_at == null);
            });

            pubs.sort(function (a,b) {
                return (a.grade < b.grade) ? -1 : 1;
            });

            // remove duplicates
            let skus = [];
            pubs = pubs.filter((pub) => {
                if (skus.includes(pub.sku))
                    return false;
                skus.push(pub.sku);
                return true;
            });

            // Group by grade
            let pubsByGrade = [];
            for (let i = 0; i < pubs.length; ++i) {
                // pubs[i].sku = displaySkuWithTopic(pubs[i].sku);
                pubs[i].physicalSku = this.legacyIdSkus[pubs[i].legacy_id]

                this.orders[pubs[i].sku] = {};


                if (typeof pubsByGrade[pubs[i].grade] === 'undefined') {
                    pubsByGrade[pubs[i].grade] = [pubs[i]];
                }
                else {
                    pubsByGrade[pubs[i].grade].push(pubs[i]);
                }
            }

            // console.log(pubs);

            for (let i =0; i < pubsByGrade.length; ++i) {
                pubsByGrade[i].sort((a, b) => {
                    return a.topic == 'Social Studies' ? -1 : (b.topic == 'Social Studies') ? 1 : 0;
                })
            }

            return pubsByGrade;
        }
    },
    data() {
        return {
            guid: guidGenerator(),
            fetchingStateData: false,
            productPrices: product_prices,
            productFormats: product_formats,
            productFormatsAdjusted: {
                null: [
                    {value: "print_online", label: "Print & Online"},
                    {value: "online_only", label: "Online Only"},
                ],
                "print_online": [
                    {value: "print_online", label: "Print & Online"},
                    {value: "online_only", label: "Online Only"}],
                "online": [
                    {value: "online_only", label: "Online Only"}],
            },
            states: states,
            editingState: false,
            printing: false,
            selectedState: null,
            orders: {},
            cartTotal: null,
            shippingPrice: "",
            form: {
                name: "",
                billingName: "",
                email: "",
                billingEmail: "",
                school: "",
                address: "",
                city: "",
                state: "",
                zip: "",
                start: "",
                phone: "",
                purchaseOrder: "",
                receiveDate: "",
                canShipPartial: 0,
                cantShipPartial: 0,
                blackoutWindows: [{},{}],
            },
        };
    },
    created() {
        this.$zendesk.hide();
        return; // TODO: remove if readded
        this.$store.dispatch('getPhysicalProducts');
        this.costsDebounceFn = _.debounce(this.getCosts, 500);
    },
    mounted() {
        // Reverts the page to the editing style when they finish printing or cancel printing
        document.body.onfocus = () => this.printing = false;

        // ctrl+p, cmd+p shortcut overrides
        this.listenToShortcuts();

        // Auto-select state
        this.setDefaultState();
    },
    methods: {
        handleTableChange() {
            // the table has been updated (format / quantity), recalculate prices
            this.costsDebounceFn.call(this);
        },
        handleClickOutside(event) {
            if (this.editingState)
                this.editingState = false;
        },
        setDefaultState() {
            let stateShortcode = (this.$route.params.stateId || this.stateData.state || null);

            if (!stateShortcode)
                return;

            let state = this.getStateObject(stateShortcode);
            this.selectedState = state || null;

            // update vuex state
            if (this.$route.params.stateId)
                this.setSelectedState()
        },
        async setSelectedState() {
            if (!this.selectedState) return;
            this.fetchingStateData = true;

            let selectedState = this.selectedState;
            this.$store.dispatch('getStateData', {state: this.selectedState.state})
                .then((response) => {
                    this.fetchingStateData = false;
                })

            this.$store.commit('setSelectedState', this.selectedState.state);
            this.$store.dispatch('getPublicationResources');

            this.$nextTick(() => this.editingState = false)
            this.selectedState = selectedState;
        },
        getStateObject(shortCode) {
            return this.states.find((stateObj) => stateObj.state.toLowerCase() === shortCode.toLowerCase());
        },


        onSubmit() {
            // alert(JSON.stringify(this.orders));
        },
        editState() {
            this.editingState = true;
            this.$nextTick(() => this.$refs.stateSelect.focus());
        },

        phoneFormatter(phoneVal, event) {
            // Replace template/mask parts
            let val = phoneVal.replaceAll(/[\(\)\- ]*/g, '');
            if (val === '')
                return '';

            // Get parts
            let parts = val.split('');
            let firstThree = parts.slice(0,3).join('');
            let secondThree = parts.slice(3,6).join('');
            let rest = parts.slice(6).join('');

            // Create masked value
            let template = `(${firstThree}`
            if (secondThree !== '')
                template += `) ${secondThree}`;
            if (rest !== '')
                template += `-${rest}`;
            return template;
        },
        getCosts() {
            let products = this.productsById();
            if (!products)
                return;

            this.$store.dispatch('cartCosts', {
                discount_code: null,
                homeschool: 0,
                shipping: {
                    "-1": {
                        state: this.selectedState.state,
                        zip: this.form.zip,
                        products: products,
                        school: null,
                    }
                },
                multiyear: 1
            })
            .then((data) => {
                this.shippingPrice = data.shipping_total;
                this.cartTotal = data.total + this.shippingPrice;

                let products = data.shipping['-1'].products;
                for (let key in products) {
                    if (!products.hasOwnProperty(key))
                        continue;
                    let product = products[key];

                    // Get updated product data
                    Object.assign(this.orders[product.sku], product);
                }
            })
        },
        printForm() {
            // check validation
            if (!this.isValidForm())
                return;

            this.printing = true;
            this.$nextTick(() => {
                window.print();

            });
        },
        isValidForm() {
            // Required fields
            return (this.form.email && this.form.name && this.form.school
                && this.form.address && this.form.city && this.form.state
                && this.form.phone);
        },
        productsById() {
            let pubs = this.publications.filter((pub) => {
                return (
                    this.orders.hasOwnProperty(pub.sku)
                    && Object.keys(this.orders[pub.sku]).length
                    && this.orders[pub.sku].quantity > 0
                    && this.orders[pub.sku].format != null
                );
            });
            return pubs.reduce((acc, product) => {
                product.quantity = this.orders[product.sku].quantity;
                product.format = this.orders[product.sku].format;
                acc[product.legacy_id] = product;
                return acc;
            }, {});
        },
        getFormatText(format) {
            if (!format) return;

            if (format.startsWith("print_online"))
                return "Print & Online"
            else if (format.startsWith("online_only"))
                return "Online Only"

            return "";
        },
        listenToShortcuts() {
            window.removeEventListener('keydown', handlePrintShortcut)
            window.addEventListener('keydown', handlePrintShortcut);

            let handlePrintShortcut = (e) => {
                if (isPrintShortcut(e)) {
                    e.preventDefault();
                    this.printForm();
                }
            }

            function isPrintShortcut(e) {
                const printCode = "KeyP";
                return e.ctrlKey && e.code == printCode || e.metaKey && e.code == printCode;
            }
        },
    },
    watch: {
        'form.canShipPartial': {
            handler (canShipPartial) {
                if (canShipPartial && this.form.cantShipPartial)
                    this.form.cantShipPartial = false;
            },
            deep: true,
        },
        'form.cantShipPartial': {
            handler (cantShipPartial) {
                if (cantShipPartial && this.form.canShipPartial)
                    this.form.canShipPartial = false;
            },
            deep: true,
        },
    }
}
</script>

<style scoped>
    #ship_partial {
        color: green;
    }
    #ship_partial:hover {
        cursor: pointer;
    }
    .state-header:hover {
        cursor: pointer;
        border: 1px solid #7a7a7a;
        border-radius: 5px;
    }
    .dot {
        vertical-align: middle;
        font-size: 30%;
    }
    .pagebreak {
        page-break-before: always;
    }

    .form-group {
        width: 50%;
        padding: 0px 5px 0 5px;
        margin-bottom: 7px;
    }

    table {
        border:solid #000 !important;
        border-width: 1px 0 0 1px !important;
    }
    th, td {
        border:solid #000 !important;
        border-width: 0 1px 1px 0 !important;
    }
    .table-bordered, .table-bordered th, .table-bordered td {
        border: 2px solid #9b9b9b;
    }

    tbody td {
        padding: 0;
    }
    table input, table div {
        height: 100%;
        width: 110px;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    table select {
        padding-left: 2px;
        min-width: 135px;
    }
    .footer .footer-img {
        vertical-align: top;
    }
    .footer img {
        width: 100%
    }

    /* Hide number arrows for number inputs */
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
    /* End hide numbers */

</style>